import React, {FC, HTMLAttributes} from 'react';
import 'antd/dist/antd.min.css';

import CloseIcon from '@svg/close.svg?react';
import ApprovedStatus from '@svg/green-v.svg?react';
import Dashboard from '@svg/dashboard.svg?react';
import Protection from '@svg/protection.svg?react';
import WebFiltering from '@svg/web-filtering.svg?react';
import WebFilteringHelpModal from '@svg/web-filtering-help-modal.svg?react';
import GeoFiltering from '@svg/geo-filtering.svg?react';
import CountriesFiltering from '@svg/countries-filtering.svg?react';
import GeoFilteringHelpModal from '@svg/geo-filtering-help-modal.svg?react';
import AppsLogo from '@svg/apps-logo.svg?react';
import ServicesLogo from '@svg/services-logo.svg?react';
import AppsAndServicesHelpModal from '@svg/apps-services-logo.svg?react';
import Insights from '@svg/reports-and-logs.svg?react';
import Activity from '@svg/activity.svg?react';
import People from '@svg/people.svg?react';
import Trash from '@svg/trash.svg?react';
import ArrowRight from '@svg/arrow-right.svg?react';
import StatusActive from '@svg/status-active.svg?react';
import StatusValidated from '@svg/status-validated.svg?react';
import StatusPending from '@svg/status-pending.svg?react';
import StatusDraft from '@svg/status-draft.svg?react';
import StatusInactive from '@svg/status-inactive.svg?react';
import MagicWand from '@svg/magic-wand.svg?react';
import Library from '@svg/library.svg?react';
import Filter from '@svg/filter.svg?react';
import Expand from '@svg/expand.svg?react';
import Export from '@svg/export.svg?react';
import New from '@svg/plus-circle.svg?react';
import Plus from '@svg/plus.svg?react';
import IPControl from '@svg/ip-control.svg?react';
import IPControlHelpModal from '@svg/ip-control-help-modal.svg?react';
import Sane from '@svg/sane.svg?react';
import Customer from '@svg/customer.svg?react';
import Location from '@svg/location.svg?react';
import CollapseButton from '@svg/collapse-button.svg?react';
import Pencil from '@svg/pencil.svg?react';
import Restore from '@svg/restore.svg?react';
import ReportItemActionsButton from '@svg/report-item-actions-button.svg?react';
import ThreeDots from '@svg/three-dots.svg?react';
import ExportExcel from '@svg/export-excel.svg?react';
import ExportCSV from '@svg/export-csv.svg?react';
import ExportJson from '@svg/export-json.svg?react';
import Refresh from '@svg/refresh.svg?react';
import Bell from '@svg/bell.svg?react';
import BlockIcon from '@svg/block-circle.svg?react';
import AllowIcon from '@svg/allow-circle.svg?react';
import Clear from '@svg/x-circle-outline.svg?react';
import FromNetwork from '@svg/arrow-from.svg?react';
import FromInternet from '@svg/arrow-from-left.svg?react';
import ATTIcon from '@svg/att-icon.svg?react';
import ApplyATT from '@svg/att-icon-black.svg?react';
import Download from '@svg/download.svg?react';
import Info from '@svg/info.svg?react';
import Zip from '@svg/zip.svg?react';
import NoResultIcon from '@svg/no-results.svg?react';
import LogsNoResultIcon from '@svg/logs-no-results.svg?react';
import LogsEmptyStateIcon from '@svg/logs-empty-state.svg?react';
import LogsLockedState from '@svg/logs-locked-state.svg?react';
import AllowEmptyStateIcon from '@svg/ip-allow-empty-state.svg?react';
import BlockEmptyStateIcon from '@svg/ip-block-empty-state.svg?react';
import FiberIcon from '@svg/fiber.svg?react';
import Firewall from '@svg/tab_ic_firewall.svg?react';
import Inventory from '@svg/library-tab.svg?react';
import CommentIcon from '@svg/comment.svg?react';
import ProtectionPlusIcon from '@svg/protection-plus-icon.svg?react';
import DynamicDefenseIcon from '@svg/dynamic-defense-icon.svg?react';
import SpywareProtectionIcon from '@svg/spyware-protection-icon.svg?react';
import VulnerabilityProtectionIcon from '@svg/vulnerability-protection-icon.svg?react';
import VirusProtectionIcon from '@svg/virus-protection-icon.svg?react';
import CheckCircle from '@svg/green-checkmark-circle.svg?react';
import ErrorIcon from '@svg/error.svg?react';
import PageActivationIcon from '@svg/activate.svg?react';
import UpgradePlanIcon from '@svg/upgrade-plan-icon.svg?react';
import AdvancedTreatProtectionIcon from '@svg/advanced-treat-protection-icon.svg?react';
import InactiveAlertIcon from '@svg/inactive-alert.svg?react';
import ExpandIcon from '@svg/expand-icon.svg?react';
import CollapseIcon from '@svg/collapse-icon.svg?react';
import UserDetails from '@svg/person.svg?react';
import SignOut from '@svg/signout.svg?react';
import Search from '@svg/search.svg?react';
import CreateSavedStatus from '@svg/v-white.svg?react';
import RedClear from '@svg/x-circle-red.svg?react';
import Copy from '@svg/copy.svg?react';
import LogsSubMenu from '@svg/log-sub-menu.svg?react';
import ActivitySubMenu from '@svg/activity-sub-menu.svg?react';
import View from '@svg/view.svg?react';
import NotificationEmptyState from '@svg/no-notifications.svg?react';
import RefreshClock from '@svg/refresh-clock.svg?react';
import AdvanceProtectionAlert from '@svg/alert-advanced-protection-icon.svg?react';
import InfoCircle from '@svg/info-circle.svg?react';
import AppsEmptyState from '@svg/apps-empty-state.svg?react';
import Link from '@svg/link.svg?react';
import ViewPolicyIcon from '@svg/view-policy-icon.svg?react';
import EmptyShield from '@svg/empty-shield.svg?react';
import PullPolicyIcon from '@svg/pull-policy-icon.svg?react';
import PushPolicyIcon from '@svg/push-policy-icon.svg?react';
import ArrowRightBlack from '@svg/arrow-right-black.svg?react';
import DnsProtectionIcon from '@svg/dns-protection-icon.svg?react';
import DDShield from '@svg/dd_shield.svg?react';
import ArrowBoth from '@svg/arrow-both.svg?react';
import Configuration from '@svg/configuration.svg?react';
import Envelope from '@svg/envelope.svg?react';
import EnvelopeV from '@svg/envelope-v.svg?react';
import EmptyList from '@svg/empty-list.svg?react';
import Smartphone from '@svg/smartphone_96.svg?react';

interface CustomIconProps extends HTMLAttributes<any> {
    type: IconType;
    size?: number;
}

export enum IconType {
    V = 'V',
    X = 'X',
    DASHBOARD = 'Dashboard',
    PROTECTION = 'Protection',
    WEB_FILTERING = 'WebFiltering',
    WEB_FILTERING_HELP_MODAL = 'WebFilteringHelpModal',
    COUNTRIES_FILTERING = 'CountriesFiltering',
    GEO_FILTERING = 'GeoFiltering',
    GEO_FILTERING_HELP_MODAL = 'GeoFilteringHelpModal',
    APPS_LOGO = 'AppsLogo',
    APPS_SERVICES_HELP_MODAL = 'AppsAndServicesHelpModal', //
    IP_CONTROL_HELP_MODAL = 'IPControlHelpModal',
    INSIGHTS = 'Insights',
    ACTIVITY = 'Activity',
    PEOPLE = 'People',
    TRASH = 'Trash',
    ARROW_RIGHT = 'ArrowRight',
    STATUS_ACTIVE = 'StatusActive',
    STATUS_VALIDATED = 'StatusValidated',
    STATUS_PENDING = 'StatusPending',
    STATUS_DRAFT = 'StatusDraft',
    STATUS_INACTIVE = 'StatusInactive',
    MAGIC_WAND = 'MagicWand',
    LIBRARY = 'Library',
    FILTER = 'Filter',
    EXPAND = 'Expand',
    EXPORT = 'Export',
    NEW = 'New',
    PLUS = 'Plus',
    IP_CONTROL = 'IPControl',
    SANE = 'Sane',
    CUSTOMER = 'Customer',
    LOCATION = 'Location',
    COLLAPSE_BUTTON = 'CollapseButton',
    PENCIL = 'Pencil',
    RESTORE = 'Restore',
    REPORT_ACTIONS_BUTTON = 'ReportActionsButton',
    THREE_DOTS = 'ThreeDots',
    EXPORT_EXCEL = 'ExportExcel',
    EXPORT_CSV = 'ExportCSV',
    EXPORT_JSON = 'ExportJson',
    BLOCK_ICON = 'BlockIcon',
    ALLOW_ICON = 'AllowIcon',
    CLEAR = 'Clear',
    RED_CLEAR = 'RedClear',
    FROM_NETWORK = 'FromNetwork',
    FROM_INTERNET = 'FromInternet',
    ATT_ICON = 'ATTIcon',
    APPLY_ATT = 'ApplyATT',
    REFRESH = 'Refresh',
    BELL = 'Bell',
    DOWNLOAD = 'Download',
    INFO = 'Info',
    ZIP = 'Zip',
    NoResult = 'NoResultIcon',
    LogsNoResult = 'LogsNoResultIcon',
    LogsEmptyState = 'LogsEmptyStateIcon',
    LogsLockedState = 'LogsLockedState',
    AllowEmptyState = 'AllowEmptyStateIcon',
    BlockEmptyState = 'BlockEmptyStateIcon',
    FIBER = 'Fiber',
    FIREWALL = 'Firewall',
    INVENTORY = 'Inventory',
    COMMENT = 'Comment',
    PROTECTION_PLUS = 'ProtectionPlus',
    DYNAMIC_DEFENSE = 'DynamicDefenseIcon',
    SPYWARE_PROTECTION = 'SpywareProtectionIcon',
    VULNERABILITY_PROTECTOIN = 'VulnerabilityProtectionIcon',
    VIRUS_PROTECTION = 'VirusProtectionIcon',
    GREEN_CHECK = 'CheckCircle',
    RED_ERROR = 'ErrorIcon',
    PageActivationIcon = 'PageActivationIcon',
    UPGRADE_PLAN = 'UpgradePlanIcon',
    ADVANCED_TREAT_PROTECTION_ICON = 'AdvancedTreatProtectionIcon',
    INACTIVE_ALERT = 'InactiveAlertIcon',
    EXTAND_ICON = 'ExtandIcon',
    COLLAPSE_ICON = 'CollapseIcon',
    USER_DETAILS = 'UserDetails',
    SIGN_OUT = 'SignOut',
    SEARCH = 'Search',
    CreateSavedStatus = 'CreateSavedStatus',
    LOGS_SUB_MENU = 'LogsSubMenu',
    COPY = 'Copy',
    ACTIVITY_SUB_MENU = 'ActivitySubMenu',
    View_Icon = 'View',
    NOTIFICATION_EMPTY_STATE = 'NotificationEmptyState',
    SERVICES_LOGO = 'ServicesLogo',
    REFRESH_CLOCK = 'RefreshClock',
    ADVANCE_PROTECTION_ALERT = 'AdvanceProtectionAlert',
    INFO_CIRCLE = 'InfoCircle',
    APPS_EMPTY_STATE = 'AppsEmptyState',
    LINK = 'Link',
    VIEW_POLICY_ICON = 'ViewPolicyIcon',
    EMPTY_SHIELD = 'EmptyShield',
    PULL_POLICY_ICON = 'PullPolicyIcon',
    PUSH_POLICY_ICON = 'PushPolicyIcon',
    ARROW_RIGHT_BLACK = 'ArrowRightBlack',
    DNS_PROTECTION_ICON = 'DnsProtectionIcon',
    DD_SHIELD = 'DDShield',
    ARROW_BOTH = 'ArrowBoth',
    CONFIGURATION = 'Configuration',
    ENVELOPE='Envelope',
    ENVELOPE_V='EnvelopeV',
    EMPTY_LIST = 'EmptyList',
    SMARTPHONE = 'Smartphone'
}

const IconMap = {
    [IconType.V]: ApprovedStatus,
    [IconType.X]: CloseIcon,
    [IconType.DASHBOARD]: Dashboard,
    [IconType.PROTECTION]: Protection,
    [IconType.WEB_FILTERING]: WebFiltering,
    [IconType.WEB_FILTERING_HELP_MODAL]: WebFilteringHelpModal,
    [IconType.COUNTRIES_FILTERING]: CountriesFiltering,
    [IconType.GEO_FILTERING]: GeoFiltering,
    [IconType.GEO_FILTERING_HELP_MODAL]: GeoFilteringHelpModal,
    [IconType.APPS_LOGO]: AppsLogo,
    [IconType.SERVICES_LOGO]: ServicesLogo,
    [IconType.APPS_SERVICES_HELP_MODAL]: AppsAndServicesHelpModal,
    [IconType.INSIGHTS]: Insights,
    [IconType.ACTIVITY]: Activity,
    [IconType.PEOPLE]: People,
    [IconType.TRASH]: Trash,
    [IconType.ARROW_RIGHT]: ArrowRight,
    [IconType.STATUS_ACTIVE]: StatusActive,
    [IconType.STATUS_VALIDATED]: StatusValidated,
    [IconType.STATUS_PENDING]: StatusPending,
    [IconType.STATUS_DRAFT]: StatusDraft,
    [IconType.STATUS_INACTIVE]: StatusInactive,
    [IconType.MAGIC_WAND]: MagicWand,
    [IconType.LIBRARY]: Library,
    [IconType.FILTER]: Filter,
    [IconType.EXPAND]: Expand,
    [IconType.EXPORT]: Export,
    [IconType.NEW]: New,
    [IconType.PLUS]: Plus,
    [IconType.IP_CONTROL]: IPControl,
    [IconType.IP_CONTROL_HELP_MODAL]: IPControlHelpModal,
    [IconType.SANE]: Sane,
    [IconType.CUSTOMER]: Customer,
    [IconType.LOCATION]: Location,
    [IconType.COLLAPSE_BUTTON]: CollapseButton,
    [IconType.PENCIL]: Pencil,
    [IconType.RESTORE]: Restore,
    [IconType.REPORT_ACTIONS_BUTTON]: ReportItemActionsButton,
    [IconType.THREE_DOTS]: ThreeDots,
    [IconType.EXPORT_EXCEL]: ExportExcel,
    [IconType.EXPORT_CSV]: ExportCSV,
    [IconType.EXPORT_JSON]: ExportJson,
    [IconType.BLOCK_ICON]: BlockIcon,
    [IconType.ALLOW_ICON]: AllowIcon,
    [IconType.CLEAR]: Clear,
    [IconType.RED_CLEAR]: RedClear,
    [IconType.FROM_NETWORK]: FromNetwork,
    [IconType.FROM_INTERNET]: FromInternet,
    [IconType.ATT_ICON]: ATTIcon,
    [IconType.APPLY_ATT]: ApplyATT,
    [IconType.REFRESH]: Refresh,
    [IconType.BELL]: Bell,
    [IconType.DOWNLOAD]: Download,
    [IconType.INFO]: Info,
    [IconType.ZIP]: Zip,
    [IconType.NoResult]: NoResultIcon,
    [IconType.LogsNoResult]: LogsNoResultIcon,
    [IconType.LogsEmptyState]: LogsEmptyStateIcon,
    [IconType.AllowEmptyState]: AllowEmptyStateIcon,
    [IconType.BlockEmptyState]: BlockEmptyStateIcon,
    [IconType.LogsLockedState]: LogsLockedState,
    [IconType.FIBER]: FiberIcon,
    [IconType.FIREWALL]: Firewall,
    [IconType.INVENTORY]: Inventory,
    [IconType.COMMENT]: CommentIcon,
    [IconType.PROTECTION_PLUS]: ProtectionPlusIcon,
    [IconType.DYNAMIC_DEFENSE]: DynamicDefenseIcon,
    [IconType.SPYWARE_PROTECTION]: SpywareProtectionIcon,
    [IconType.VULNERABILITY_PROTECTOIN]: VulnerabilityProtectionIcon,
    [IconType.VIRUS_PROTECTION]: VirusProtectionIcon,
    [IconType.GREEN_CHECK]: CheckCircle,
    [IconType.RED_ERROR]: ErrorIcon,
    [IconType.PageActivationIcon]: PageActivationIcon,
    [IconType.UPGRADE_PLAN]: UpgradePlanIcon,
    [IconType.ADVANCED_TREAT_PROTECTION_ICON]: AdvancedTreatProtectionIcon,
    [IconType.INACTIVE_ALERT]: InactiveAlertIcon,
    [IconType.EXTAND_ICON]: ExpandIcon,
    [IconType.COLLAPSE_ICON]: CollapseIcon,
    [IconType.USER_DETAILS]: UserDetails,
    [IconType.SIGN_OUT]: SignOut,
    [IconType.SEARCH]: Search,
    [IconType.CreateSavedStatus]: CreateSavedStatus,
    [IconType.COPY]: Copy,
    [IconType.LOGS_SUB_MENU]: LogsSubMenu,
    [IconType.ACTIVITY_SUB_MENU]: ActivitySubMenu,
    [IconType.View_Icon]: View,
    [IconType.NOTIFICATION_EMPTY_STATE]: NotificationEmptyState,
    [IconType.REFRESH_CLOCK]: RefreshClock,
    [IconType.ADVANCE_PROTECTION_ALERT]: AdvanceProtectionAlert,
    [IconType.INFO_CIRCLE]: InfoCircle,
    [IconType.APPS_EMPTY_STATE]: AppsEmptyState,
    [IconType.LINK]: Link,
    [IconType.VIEW_POLICY_ICON]: ViewPolicyIcon,
    [IconType.EMPTY_SHIELD]: EmptyShield,
    [IconType.PULL_POLICY_ICON]: PullPolicyIcon,
    [IconType.PUSH_POLICY_ICON]: PushPolicyIcon,
    [IconType.ARROW_RIGHT_BLACK]: ArrowRightBlack,
    [IconType.DNS_PROTECTION_ICON]: DnsProtectionIcon,
    [IconType.DD_SHIELD]: DDShield,
    [IconType.ARROW_BOTH]: ArrowBoth,
    [IconType.CONFIGURATION]: Configuration,
    [IconType.ENVELOPE]:Envelope,
    [IconType.ENVELOPE_V]:EnvelopeV,
    [IconType.EMPTY_LIST]:EmptyList,
    [IconType.SMARTPHONE]:Smartphone

};

const CustomIcon: FC<CustomIconProps> = (props) => {
    const Icon = IconMap[props.type];
    return <Icon className={props.type} {...props} data-testid={`${props.type}-icon`}
        style={props.size ? { height: `${props.size}px`, width: `${props.size}px` } : {}} />;
};
export default CustomIcon;
